import { render } from "./EditLeaveType.vue?vue&type=template&id=094f309e&scoped=true"
import script from "./EditLeaveType.vue?vue&type=script&lang=js"
export * from "./EditLeaveType.vue?vue&type=script&lang=js"

import "./leave-type.scss?vue&type=style&index=0&id=094f309e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094f309e"]])

export default __exports__